import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface ModalCancelQuoteProps extends ModalCancelQuoteLogicProps {
}

const ModalCancelQuote: React.FC<ModalCancelQuoteProps> = ({ setOpened, onSubmit, allRowData, url }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalCancelQuoteLogic({ setOpened, onSubmit, allRowData, url })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleOnAccept} translations={{
            title: t('sureCancelQuote', '¿Seguro quieres cancelar este presupuesto?'),
            subtitle: t('possibleToReopenForItsModification', 'Podrás reabrirlo para modificarlo si fuera necesario'),
            buttonAccept: t('cancel', 'Cancelar'),
            buttonCancel: t('return', 'Volver')
        }} loading={loading} />
    )
}

interface ModalCancelQuoteLogicProps extends ModalEditComponentProps {
    url: string
}

const useModalCancelQuoteLogic = ({ allRowData, onSubmit, url }: ModalCancelQuoteLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleOnAccept = useCallback(async () => {
        startLoading?.()
        const result = await twinFetchPostJSON(url, { ...allRowData || {} })
        if (result) {
            onSubmit?.(result, {})
        }
        endLoading?.()
    }, [startLoading, endLoading, onSubmit, allRowData, url])
    return { handleOnAccept, loading }
}


export default ModalCancelQuote